import { useParams, Link } from 'react-router-dom';
import { FaArrowLeft, FaInfoCircle, FaFileContract } from 'react-icons/fa';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function ConcesionDetail() {
    const { id } = useParams();
    const [concesion, setConcesion] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchConcesion = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/concesiones/${id}`);
                setConcesion(response.data);
            } catch (err) {
                setError('Error al cargar los detalles de la concesión. Por favor, intente de nuevo.');
                console.error('Error fetching concesion details:', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchConcesion();
    }, [id]);

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mx-auto px-4 py-8">
                <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded" role="alert">
                    <p className="font-bold">Error</p>
                    <p>{error}</p>
                </div>
            </div>
        );
    }

    if (!concesion) {
        return (
            <div className="container mx-auto px-4 py-8">
                <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded" role="alert">
                    <p className="font-bold">Advertencia</p>
                    <p>No se encontró la concesión</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-8">
            <Link to="/home/concesiones" className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-6 transition-colors duration-200">
                <FaArrowLeft className="mr-2" /> Volver a la lista de concesiones
            </Link>
            <div className="bg-white shadow-2xl rounded-lg overflow-hidden">
                <div className="bg-gradient-to-r from-indigo-600 to-indigo-800 p-6 text-white">
                    <h2 className="text-3xl font-bold flex items-center">
                        <FaFileContract className="mr-4 text-4xl" />
                        Concesión #{concesion.id}
                    </h2>
                </div>
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    {[
                        { label: 'Lugar ID', value: concesion.lugarId },
                        { label: 'Tipo ID', value: concesion.tipoId },
                        { label: 'Fecha', value: concesion.fecha },
                        { label: 'Observaciones', value: concesion.observaciones },
                        { label: 'Tercero ID', value: concesion.terceroId },
                        { label: 'Sepultura ID', value: concesion.sepulturaId },
                        { label: 'Serie', value: concesion.serie },
                        { label: 'Número', value: concesion.numero }
                    ].map((item, index) => (
                        <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg">
                            <h3 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
                                <FaInfoCircle className="mr-2 text-yellow-600" /> {item.label}
                            </h3>
                            <p className="text-gray-700">{item.value || 'No disponible'}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

